import { APIEnvironments } from '@evertel/api'
import * as Electron from '../utilities/electronInterface'
import { ApiWeb } from './ApiWeb'
import { resolveApiEnvironment } from './resolve-api-environment'

function determineApiEnvironment(): APIEnvironments {
    return resolveApiEnvironment({
        hostname: window?.location?.hostname,
        viteApiEnv: import.meta.env.VITE_API_ENV,
        isElectronProduction: Electron.isProduction()
    })
}

const apiWebInstance = new ApiWeb(
    determineApiEnvironment(),
    true,
    'Web',
    (__BUILD__.NUMBER || '').toString()
)

const LOG_LEVELS = {
    NONE: 'NONE',
    VERBOSE: 'VERBOSE',
    VERY_VERBOSE: 'VERY_VERBOSE'
}

function createRequestLogger(logLevel) {
    return (request) => {
        if (logLevel === LOG_LEVELS.NONE) return request

        request.metadata = { startTime: new Date() }

        const baseLog = ['REQUEST', request.method, request.url, request.params]

        if (logLevel === LOG_LEVELS.VERY_VERBOSE) {
            console.log([
                ...baseLog,
                'HEADERS', request.headers,
                'BODY', request.data
            ])
        } else if (logLevel === LOG_LEVELS.VERBOSE) {
            console.log(baseLog)
        }

        return request
    }
}

function createResponseLogger(logLevel) {
    return (response) => {
        if (logLevel === LOG_LEVELS.NONE) return response

        const duration = new Date().valueOf() - response.config.metadata.startTime
        const baseLog = ['RESPONSE', response.config.url, response.status, duration]

        if (logLevel === LOG_LEVELS.VERY_VERBOSE) {
            const dataString = JSON.stringify(response.data, null, 2)
            const truncatedData = dataString.length > 1024 ? `${dataString.substring(0, 1024)}...` : dataString
            console.log([...baseLog, truncatedData])
        } else if (logLevel === LOG_LEVELS.VERBOSE) {
            console.log(baseLog)
        }

        return response
    }
}

apiWebInstance.addRequestInterceptor(createRequestLogger(apiWebInstance.logLevel))
apiWebInstance.addResponseInterceptor(createResponseLogger(apiWebInstance.logLevel), null)


export { apiWebInstance }
export default apiWebInstance

